// extracted by mini-css-extract-plugin
module.exports = {"productId":"ProductDescription_productId__9IY2c"};